import { APICore } from '../../helpers/api/apiCore';
import * as URL from "../../helpers/api/apiEndPoint"

const api = new APICore();


function wareHouse(params: any): any {
    const { search, limit, pages } = params.data
    return api.get(`${URL.WARE_HOUSE_GET}?search=${encodeURIComponent(search)}&limit=${limit}&page=${pages}`);
}

function createWareHouse(params: any): any {
    const { data } = params
    return api.create(URL.WARE_HOUSE_POST, data);
}
function updateWareHouse(params: any): any {
    const { data } = params
    return api.update(URL.WARE_HOUSE_UPDATE, data);
}
function deleteWareHouse(params: any): any {
    const { data } = params;
    return api.delete(`${URL.WARE_HOUSE_DELETE}?_id=${data?.id}`);
}
function uploadWareHouse(params: any): any {
    const { data } = params;
    return api.create(URL.WARE_HOUSE_POST, data);
}

export { wareHouse, createWareHouse, updateWareHouse, deleteWareHouse, uploadWareHouse }